export const computeRoundedNumber = (
  toRound: number,
  numberOfDecimals: number
): number => {
  const roundBy = Number(`1e${numberOfDecimals}`);

  return Math.round(toRound * roundBy) / roundBy;
};
